module.exports = __webpack_public_path__ + "static/img/2.2ae90b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/2.jpg
// module id = NNsN
// module chunks = 1